import { FC, MouseEvent, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router-dom";

import Button from "@/components/Button";
import {
  FilterWrap,
  FilterGroupTitle,
  FilterGroupHeader,
  FilterGroupBody,
} from "@/components/FilterDropdown/Parts";
import FiltersDropdown from "@/components/FilterDropdown";
import FilterRadioButton from "@/components/FilterDropdown/FilterRadioButton";
import { ReportResource } from "@/types/resources";

const StyledFilterWrap = styled(FilterWrap)`
  margin-left: auto;
`;

interface Props {
  reports: Array<Pick<ReportResource, "id" | "name">>;
}

const ReportsNavigationDropdown: FC<Props> = ({ reports }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const { teamId, groupId, reportId } = useParams();

  const navigate = useNavigate();

  const onChange = (reportId: string) =>
    navigate(`/teams/${teamId}/reports/other/${groupId}/${reportId}`);

  return (
    <StyledFilterWrap>
      <Button
        color="secondary"
        small
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation();
          setShowDropdown((prev) => !prev);
        }}
      >
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.9236 14.8571H3.06641V4.14282"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.9236 7.35706L11.6378 11.1071L7.35212 7.89277L3.06641 11.6428"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Reports
      </Button>
      {showDropdown && (
        <FiltersDropdown onClose={() => setShowDropdown(false)}>
          <FilterGroupHeader>
            <FilterGroupTitle>Reports list:</FilterGroupTitle>
          </FilterGroupHeader>
          <FilterGroupBody>
            {reports.map((report) => (
              <FilterRadioButton
                key={report.id}
                id={`reportRadio${report.id}`}
                value={report.id.toString()}
                checked={report.id.toString() === reportId}
                setValue={onChange}
              >
                {report.name}
              </FilterRadioButton>
            ))}
          </FilterGroupBody>
        </FiltersDropdown>
      )}
    </StyledFilterWrap>
  );
};

export default ReportsNavigationDropdown;
